<template>
    <div>
        <div class="summary-bar pt-3 font-weight-bold" v-if="totalRecords">
            Total Records: {{ totalRecords }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'SummaryBar',
    data() {
        return {};
    },
    computed: {
        totalRecords() {
            return this.params.totalRecords();
        },
    },
};
</script>
